import { render } from "./welcomeMessage.vue?vue&type=template&id=15f75988&scoped=true"
import script from "./welcomeMessage.vue?vue&type=script&lang=js"
export * from "./welcomeMessage.vue?vue&type=script&lang=js"

import "./welcomeMessage.vue?vue&type=style&index=0&id=15f75988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f75988"]])

export default __exports__